import BaseMessageHandler from 'messages/BaseMessageHandler';
import { saveDataState } from 'actions/getData';

export default class Balance_RealTime extends BaseMessageHandler {
  success = () => {
    const {
      dispatch,
      message: { payload: { rows, totals } },
    } = this;

    dispatch(saveDataState('balanceRealTime', {
      items: rows,
      totals: totals,
    }));
  };
}
